/* eslint-disable jsx-a11y/anchor-is-valid */

export function Login() {
  return (
    <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
      <div className="w-100" id="kt_login_signin_form">
        {/* begin::Heading */}
        <div className="text-center mb-10">
          <h1 className="text-dark mb-3">سامانه تبلیغات کی پلاس</h1>
        </div>
        {/* begin::Heading */}

        {/* end::Form group */}
        <a href="https://accounts.kplus.holdings/?srv=ads">
          <button
            type="submit"
            id="kt_sign_in_submit"
            className="btn btn-lg btn-primary w-100 mb-5"
          >
            ورود و ثبت نام
          </button>
        </a>
        {/* end::Form group */}
      </div>
    </div>
  );
}
